/*       */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { RouterMatchPropTypeBuilder } from 'app/utils/propTypes/common';
import WorkspacesList from 'app/containers/Admin/Workspaces/WorkspacesList';
import WorkspaceDetails from 'app/containers/Admin/Workspaces/Details/WorkspaceDetails';
import PageNotAllowed from 'app/containers/ErrorPages/PageNotAllowed';

/**
 * Defines the routes for the Workspaces & Permissions views
 */
class WorkspacesRoute extends Component {
    static propTypes = {
        match: RouterMatchPropTypeBuilder({ id: PropTypes.string }),
        userProfile: PropTypes.object,
    };

    /**
     * @override
     * Always make sure you use PageTemplate as PageContainer
     */
    render() {
        const { match } = this.props;
        const { permissions, isAdmin } = this.props.userProfile;
        const permissionsSet = new Set(permissions || []);
        const canView = isAdmin || permissionsSet.has('admin.workspace');
        if (!canView) {
            return <PageNotAllowed title="Workspaces" />;
        }
        return (
            <Fragment>
                <Switch>
                    <Route path={`${match.url}`} exact component={WorkspacesList} />
                    <Route path={`${match.url}/:id/about`} component={WorkspaceDetails} />
                    <Route path={`${match.url}/:id/history`} exact component={WorkspaceDetails} />
                    <Route path={`${match.url}/:id`} exact component={WorkspaceDetails} />
                </Switch>
            </Fragment>
        );
    }
}

export default connect(state => ({ userProfile: state.user.profile }))(WorkspacesRoute);
